import { termApi } from "../../api";

const TermService = {
  fetchDropdown: async () => {
    const response = await termApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default TermService;
